import { JsonQuery, type TJsonQuery, setTerms, term } from '@/packages/JsonQuery';
import { type SortType } from '@/packages/api-models/common/json_query';

export const insertPageToJsonQuery =
  (page: number | null | undefined) =>
  (jsonQuery: TJsonQuery): TJsonQuery => {
    const nextJsonQuery = new JsonQuery(jsonQuery).toJSON();

    if (page && page > 1) {
      nextJsonQuery.page = term(page);
    }

    return nextJsonQuery;
  };

export const insertSortToJsonQuery =
  (sort: SortType | null | undefined) =>
  (jsonQuery: TJsonQuery): TJsonQuery => {
    const nextJsonQuery = new JsonQuery(jsonQuery).toJSON();

    if (sort && sort !== 'default') {
      nextJsonQuery.sort = term(sort);
    }

    return nextJsonQuery;
  };

export const insertBboxToJsonQuery =
  (bbox: [[lngMax: number, latMin: number], [lngMin: number, latMax: number]] | undefined) =>
  (jsonQuery: TJsonQuery): TJsonQuery => {
    const nextJsonQuery = new JsonQuery(jsonQuery).toJSON();

    if (bbox) {
      nextJsonQuery.bbox = term(bbox);
    }

    return nextJsonQuery;
  };

export const insertRegionToJsonQuery =
  (regionId: number) =>
  (jsonQuery: TJsonQuery): TJsonQuery => {
    return setTerms('region')(jsonQuery)([regionId]);
  };
